// @flow

import { curry } from 'lodash';

import fuzzysearch from '@zapier/common-utils/src/fuzzysearch';

import { NAME } from './constants';

const matchesQuery = curry((query, service) => {
  return fuzzysearch(query, service[NAME]);
});

export default matchesQuery;
